import CardLayout from '@/app/component/layout/card'
import ErrorLayout from '@/app/component/layout/error'
import Layout from '@/app/component/layout/page'
import { AuthHeader } from '@/app/module/auth'

export default function ErrorPage() {
  return (
    <Layout title="Error - engageSPARK">
      <AuthHeader />
      <CardLayout>
        <ErrorLayout status={500}>A server error occurred</ErrorLayout>
      </CardLayout>
    </Layout>
  )
}
